import { fetchRetryParameters, requestHostHeaders, type RequestHostHeadersType } from '~/composables/constants/api'
import type { FlagItem } from '~/types/searchTypes'

export default async (langId: number | null, locale: string): Promise<FlagItem[]> => {
  try {
    return await $fetch<FlagItem[]>('/api/search/flags', {
      method: 'POST',
      body: {
        langId,
        locale,
      },
      ...fetchRetryParameters,
      headers: useRequestHeaders<RequestHostHeadersType>(requestHostHeaders),
    })
  } catch (error) {
    return []
  }
}
